export default __webpack_public_path__ + "static/media/signedToken.610bb264.proto";